export const validateRequired = value =>
  value ? undefined : 'Please complete';

export const validatePasswordLength = value =>
  value && value.length < 8 ? 'Password must be at least 8 characters' : '';

export const validatePasswordsMatch = (value, allValues) =>
  value !== allValues.get('password') ? "Passwords don't match" : undefined;
